<template>
  <div>
    <el-table :data="tableData" style="width: 100%;">
      <el-table-column prop="operationType" label="operation">
        <template slot-scope="{ row }">
          <span>{{ row.operationType | operationType }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="officeStaff" label="Office Staff">
      </el-table-column>
      <el-table-column prop="oldStatus" label="Old Status">
        <template slot-scope="{ row }">
          <span>{{ row.oldStatus | applicationStatus }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="newStatus" label="New Status">
        <template slot-scope="{ row }">
          <span>{{ row.newStatus | applicationStatus }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="changeTime" label="change time">
        <template slot-scope="{ row }">
          <span>{{ row.changeTime | formatDateTime }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function () {},
    },
  },
};
</script>

<style lang="scss" scoped>
</style>